export default __webpack_public_path__ + "static/media/FengLoaderWhitePNG.d876433e.png";